var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { container } from 'tsyringe';
import { types } from './mutations';
import { FeatureRepository } from 'packages/features/FeatureRepository';
import { TalentAttributesRepository } from 'packages/v3/TalentAttributesRepository';
export var actions = {
    setRoute: function (_a, route) {
        var commit = _a.commit;
        commit(types.SET_ROUTE, route);
    },
    loadFeatures: function (_a, companyId) {
        var commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            var _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _b = commit;
                        _c = [types.SET_FEATURES];
                        return [4 /*yield*/, container.resolve(FeatureRepository).retrieve(companyId)];
                    case 1:
                        _b.apply(void 0, _c.concat([_d.sent()]));
                        return [2 /*return*/];
                }
            });
        });
    },
    setFeatures: function (_a, payload) {
        var commit = _a.commit, dispatch = _a.dispatch;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, (container.resolve(FeatureRepository).set(payload.companyId, payload.features))];
                    case 1:
                        _b.sent();
                        return [2 /*return*/, dispatch('loadFeatures', payload.companyId)];
                }
            });
        });
    },
    loadAttributes: function (_a, companyId) {
        var commit = _a.commit, state = _a.state;
        return __awaiter(this, void 0, void 0, function () {
            var _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (state.loadingAttributes) {
                            return [2 /*return*/];
                        }
                        commit(types.SET_LOADING_ATTRIBUTES, true);
                        _b = commit;
                        _c = [types.SET_ATTRIBUTES];
                        return [4 /*yield*/, container.resolve(TalentAttributesRepository).list(companyId)];
                    case 1:
                        _b.apply(void 0, _c.concat([_d.sent()]));
                        commit(types.SET_LOADING_ATTRIBUTES, false);
                        return [2 /*return*/];
                }
            });
        });
    },
    createAttribute: function (_a, payload) {
        var commit = _a.commit, state = _a.state;
        return __awaiter(this, void 0, void 0, function () {
            var newAttr;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, container.resolve(TalentAttributesRepository).create(payload.attribute, { company: payload.companyId })];
                    case 1:
                        newAttr = _b.sent();
                        commit(types.SET_ATTRIBUTES, __spreadArray(__spreadArray([], state.attributes), [newAttr]));
                        return [2 /*return*/, newAttr];
                }
            });
        });
    },
    updateAttribute: function (_a, payload) {
        var commit = _a.commit, dispatch = _a.dispatch;
        return __awaiter(this, void 0, void 0, function () {
            var update;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, container.resolve(TalentAttributesRepository).update(payload.attribute.id, payload.attribute, { company: payload.companyId })];
                    case 1:
                        update = _b.sent();
                        return [4 /*yield*/, dispatch('loadAttributes', { companyId: payload.companyId })];
                    case 2:
                        _b.sent();
                        return [2 /*return*/, update];
                }
            });
        });
    },
    useAsMobile: function (_a) {
        var commit = _a.commit;
        var meta = document.querySelector('meta[name=viewport]');
        meta.setAttribute('content', 'width=device-width, initial-scale=1');
        commit(types.SET_USING_MOBILE, true);
        commit(types.SET_HIDE_MAIN_NAV, true);
    },
    useAsDesktop: function (_a) {
        var commit = _a.commit;
        var meta = document.querySelector('meta[name=viewport]');
        meta.setAttribute('content', 'width=1024');
        commit(types.SET_USING_MOBILE, false);
        commit(types.SET_HIDE_MAIN_NAV, false);
    },
};
